export default __webpack_public_path__ + "static/requestDemo-e89ffd224aca8c68c77a40635aeb8d43.svg";